import { useState, useCallback } from 'react';
import { CartUIState } from './types';

export const useCartUI = (): CartUIState & {
  showCart: () => void;
  hideCart: () => void;
  showUpsellModal: (primaryVariantId?: string) => void;
  hideUpsellModal: () => void;
} => {
  const [cartVisible, setCartVisible] = useState<boolean>(false);
  const [altContent, setAltContent] = useState<React.ReactNode | null>(null);
  const [isUpsellVisible, setIsUpsellVisible] = useState<boolean>(false);
  const [primaryProductForUpsell, setPrimaryProductForUpsell] = useState<
    string | null
  >(null);

  // Cart visibility functions
  const showCart = useCallback(() => {
    setCartVisible(true);
  }, []);

  const hideCart = useCallback(() => {
    setAltContent(null);
    setCartVisible(false);
  }, []);

  // Upsell modal functions
  const showUpsellModal = useCallback((primaryVariantId?: string) => {
    setPrimaryProductForUpsell(primaryVariantId || null);
    setIsUpsellVisible(true);
  }, []);

  const hideUpsellModal = useCallback(() => {
    setIsUpsellVisible(false);
    setPrimaryProductForUpsell(null);
  }, []);

  return {
    cartVisible,
    setCartVisible,
    altContent,
    setAltContent,
    isUpsellVisible,
    setIsUpsellVisible,
    primaryProductForUpsell,
    setPrimaryProductForUpsell,
    showCart,
    hideCart,
    showUpsellModal,
    hideUpsellModal,
  };
};
